/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getDocumentsByEmployee,
  createDocument,
  updateDocument,
  uploadDocumentFile,
  deleteDocument,
  clearDocuments,
  checkEmployeeCompleteness,
  // getDocumentViewLink,
  validateDoc,
} from "../../store/slices/governmentDocumentSlice";
import { fetchEmployeeById } from "../../store/slices/employeeDetailSlice";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Alert } from "bootstrap";
import { DateUtils } from "../../utils/convertDate";

const GovernmentDocType = {
  SSS: "SSS",
  PHILHEALTH: "PhilHealth",
  PAGIBIG: "Pag-IBIG",
  TIN: "TIN",
  NBI: "NBI Clearance",
  PASSPORT: "Passport",
  PEOS: "PEOS",
  EREGISTRATION: "E-Registration",
  INSURANCEPOLICY: "Insurance Policy",
  BIRTHCERTIFICATE: "Birth Certificate",
  OEC: "OEC",
  PDOS: "PDOS",
  MEDICAL: "Medical",
  DRIVERSLICENSE: "Driver's License",
  MARRIAGECERTIFICATE: "Marriage Certificate",
  HEALTHCARD: "Health Card",
  OCCUPATIONALPERMIT: "Occupational Permit",
  PRCID: "PRC ID",
  COE: "Certificate of Employment",
  APOSTILLEDDOCUMENTS: "Apostilled Documents",
  CERTIFICATION: "Certification",
  DIPLOMA: "Diploma",
  TOR: "Transcript of Records",
  OTHER: "Other",
};

const EmployeeGovernmentDoc = () => {
  const dispatch = useDispatch();
  const { id: employeeId } = useParams();
  const { documents = [], status } = useSelector(
    (state) => state.governmentDocument,
  );
  const { employee } = useSelector((state) => state.employeeDetail);

  const isSeasonal = employee?.isSeasonal === true;

  const [statusMsg, setStatusMsg] = useState({ text: "", type: "success" });
  const [isProcessing, setIsProcessing] = useState(false);
  const [isAddingOther, setIsAddingOther] = useState(false);

  const initialSectionState = (type) => ({
    docType: type,
    docName: "",
    idNumber: "",
    file: null,
    docId: null,
    isValidated: false,
    editing: false,
    customName: "",
  });

  const [sss, setSss] = useState(initialSectionState(GovernmentDocType.SSS));
  const [philHealth, setPhilHealth] = useState(
    initialSectionState(GovernmentDocType.PHILHEALTH),
  );
  const [pagIbig, setPagIbig] = useState(
    initialSectionState(GovernmentDocType.PAGIBIG),
  );
  const [TIN, setTIN] = useState(initialSectionState(GovernmentDocType.TIN));
  const [NBI, setNBI] = useState(initialSectionState(GovernmentDocType.NBI));
  const [otherDocs, setOtherDocs] = useState([]);
  const [newOther, setNewOther] = useState(
    initialSectionState(GovernmentDocType.OTHER),
  );

  const [passport, setPassport] = useState(
    initialSectionState(GovernmentDocType.PASSPORT),
  );
  const [peos, setPeos] = useState(initialSectionState(GovernmentDocType.PEOS));
  const [eRegistration, setERegistration] = useState(
    initialSectionState(GovernmentDocType.EREGISTRATION),
  );
  const [insurancePolicy, setInsurancePolicy] = useState(
    initialSectionState(GovernmentDocType.INSURANCEPOLICY),
  );
  const [oec, setOec] = useState(initialSectionState(GovernmentDocType.OEC));
  const [pdos, setPdos] = useState(initialSectionState(GovernmentDocType.PDOS));
  const [medical, setMedical] = useState(
    initialSectionState(GovernmentDocType.MEDICAL),
  );
  const [driversLicense, setDriversLicense] = useState(
    initialSectionState(GovernmentDocType.DRIVERSLICENSE),
  );
  const [birthCertificate, setBirthCertificate] = useState(
    initialSectionState(GovernmentDocType.BIRTHCERTIFICATE),
  );
  const [marriageCertificate, setMarriageCertificate] = useState(
    initialSectionState(GovernmentDocType.MARRIAGECERTIFICATE),
  );
  const [healthCard, setHealthCard] = useState(
    initialSectionState(GovernmentDocType.HEALTHCARD),
  );
  const [occupationalPermit, setOccupationalPermit] = useState(
    initialSectionState(GovernmentDocType.OCCUPATIONALPERMIT),
  );
  const [prcId, setPrcId] = useState(
    initialSectionState(GovernmentDocType.PRCID),
  );
  const [coe, setCoe] = useState(initialSectionState(GovernmentDocType.COE));
  const [apostilledDocs, setApostilledDocs] = useState(
    initialSectionState(GovernmentDocType.APOSTILLEDDOCUMENTS),
  );
  const [certification, setCertification] = useState(
    initialSectionState(GovernmentDocType.CERTIFICATION),
  );
  const [diploma, setDiploma] = useState(
    initialSectionState(GovernmentDocType.DIPLOMA),
  );
  const [tor, setTor] = useState(initialSectionState(GovernmentDocType.TOR));

  useEffect(() => {
    if (employeeId) {
      dispatch(getDocumentsByEmployee(employeeId));
      dispatch(fetchEmployeeById(employeeId));
    }
    return () => dispatch(clearDocuments());
  }, [employeeId, dispatch]);

  // useEffect(() => {
  //   const mapDocument = (type, setter) => {
  //     const existing = documents.find((d) => d.docType === type);
  //     if (existing) {
  //       setter({
  //         docType: type,
  //         docName: existing.docName || null,
  //         idNumber: existing.idNumber || "",
  //         file: existing.file || existing.file_url || null,
  //         isValidated: existing.isValidated || false,
  //         docId: existing.docId || existing.id || null,
  //         editing: false,
  //       });
  //     } else {
  //       setter(initialSectionState(type));
  //     }
  //   };

  //   const others = documents
  //     .filter((d) => d.docType === GovernmentDocType.OTHER)
  //     .map((d) => ({
  //       docType: GovernmentDocType.OTHER,
  //       docName: d.docName || "",
  //       idNumber: d.idNumber || d.id_number || "",
  //       file: d.file || d.file_url || null,
  //       isValidated: d.isValidated || false,
  //       docId: d.docId || d.id,
  //       editing: false,
  //     }));
  //   setOtherDocs(others);

  //   [
  //     [GovernmentDocType.SSS, setSss],
  //     [GovernmentDocType.PHILHEALTH, setPhilHealth],
  //     [GovernmentDocType.PAGIBIG, setPagIbig],
  //     [GovernmentDocType.TIN, setTIN],
  //     [GovernmentDocType.NBI, setNBI],
  //   ].forEach(([type, setter]) => mapDocument(type, setter));
  // }, [documents]);

  useEffect(() => {
    // 1. Define the sets at the very top of the effect
    const standardDocs = [
      [GovernmentDocType.SSS, setSss],
      [GovernmentDocType.PHILHEALTH, setPhilHealth],
      [GovernmentDocType.PAGIBIG, setPagIbig],
      [GovernmentDocType.TIN, setTIN],
      [GovernmentDocType.NBI, setNBI],
    ];

    const wizardDocs = [
      [GovernmentDocType.SSS, setSss], // Added these to Wizard just in case
      [GovernmentDocType.PHILHEALTH, setPhilHealth],
      [GovernmentDocType.PAGIBIG, setPagIbig],
      [GovernmentDocType.TIN, setTIN],
      [GovernmentDocType.NBI, setNBI],
      [GovernmentDocType.PASSPORT, setPassport],
      [GovernmentDocType.PEOS, setPeos],
      [GovernmentDocType.EREGISTRATION, setERegistration],
      [GovernmentDocType.INSURANCEPOLICY, setInsurancePolicy],
      [GovernmentDocType.OEC, setOec],
      [GovernmentDocType.PDOS, setPdos],
      [GovernmentDocType.MEDICAL, setMedical],
      [GovernmentDocType.DRIVERSLICENSE, setDriversLicense],
      [GovernmentDocType.BIRTHCERTIFICATE, setBirthCertificate],
      [GovernmentDocType.MARRIAGECERTIFICATE, setMarriageCertificate],
      [GovernmentDocType.HEALTHCARD, setHealthCard],
      [GovernmentDocType.OCCUPATIONALPERMIT, setOccupationalPermit],
      [GovernmentDocType.PRCID, setPrcId],
      [GovernmentDocType.COE, setCoe],
      [GovernmentDocType.APOSTILLEDDOCUMENTS, setApostilledDocs],
      [GovernmentDocType.CERTIFICATION, setCertification],
      [GovernmentDocType.DIPLOMA, setDiploma],
      [GovernmentDocType.TOR, setTor],
    ];

    // 2. Guard: Don't map if we don't have documents yet
    if (!documents || documents.length === 0) return;

    const mapDocument = (type, setter) => {
      const existing = documents.find((d) => {
        const dbType = String(d.docType || "").toLowerCase();
        const searchType = String(type || "").toLowerCase();
        return dbType.includes(searchType) || searchType.includes(dbType);
      });

      if (existing) {
        setter({
          docType: type,
          docName: existing.docName || type,
          idNumber: existing.idNumber || existing.id_number || "",
          file: existing.file || existing.file_url || null,
          isValidated: existing.isValidated || false,
          docId: existing.docId || existing.id || null,
          editing: false,
        });
      } else {
        // Keep initial state if not found
        setter(initialSectionState(type));
      }
    };

    // 3. Select the correct list
    const companyName = employee?.company?.companyName || "";
    const currentDocSet =
      companyName === "Wizard International Manpower Services, Inc."
        ? wizardDocs
        : standardDocs;

    // 4. Run the mapping
    currentDocSet.forEach(([type, setter]) => mapDocument(type, setter));

    // 5. Handle "Other" documents
    const others = documents
      .filter((d) => d.docType === GovernmentDocType.OTHER)
      .map((d) => ({
        docType: GovernmentDocType.OTHER,
        docName: d.docName || "",
        idNumber: d.idNumber || d.id_number || "",
        file: d.file || d.file_url || null,
        isValidated: d.isValidated || false,
        docId: d.docId || d.id,
        editing: false,
      }));
    setOtherDocs(others);
  }, [documents, employee, employee?.company?.companyName]);

  const showStatus = (text, type = "success") => {
    setStatusMsg({ text, type });
    setTimeout(() => setStatusMsg({ text: "", type: "success" }), 4000);
  };

  // const handleViewFile = (url) => {
  //   // dispatch(getDocumentViewLink({ docId }))
  //   //   .unwrap()
  //   //   .then((payload) => {
  //   //     // Open the Zoho viewer in a new tab immediately
  //   //     console.log(payload)
  //   //     window.open(payload.viewUrl, "_blank", "noopener,noreferrer");
  //   //   })
  //   //   .catch((err) => {
  //   //     console.error("Failed to get Zoho link:", err);
  //   //   });
  //   window.open(url, "_blank", "noopener,noreferrer");
  // };

  // const handleViewFile = (url) => {
  //   // dispatch(getDocumentViewLink({ docId }))
  //   //   .unwrap()
  //   //   .then((payload) => {
  //   //     // Open the Zoho viewer in a new tab immediately
  //   //     console.log(payload)
  //   //     window.open(payload.viewUrl, "_blank", "noopener,noreferrer");
  //   //   })
  //   //   .catch((err) => {
  //   //     console.error("Failed to get Zoho link:", err);
  //   //   });
  //   window.open(url, "_blank", "noopener,noreferrer");
  // };

  // const handleViewFile = (url) => {
  //   // dispatch(getDocumentViewLink({ docId }))
  //   //   .unwrap()
  //   //   .then((payload) => {
  //   //     // Open the Zoho viewer in a new tab immediately
  //   //     console.log(payload)
  //   //     window.open(payload.viewUrl, "_blank", "noopener,noreferrer");
  //   //   })
  //   //   .catch((err) => {
  //   //     console.error("Failed to get Zoho link:", err);
  //   //   });
  //   window.open(url, "_blank", "noopener,noreferrer");
  // };

  const handleViewFile = (url) => {
    // 1. Check if the URL is null, undefined, or an empty string
    if (!url) {
      // Return an error notification to the user
      console.log(url);
      window.alert(
        `Document link is missing or hasn't been uploaded yet. ${url}`,
      );
      // return; // Exit the function
    }
    console.log(url);
    // 2. Navigate if the URL exists
    window.open(url, "_blank", "noopener,noreferrer");
  };

  // const handleViewFile = (url) => {
  //   // dispatch(getDocumentViewLink({ docId }))
  //   //   .unwrap()
  //   //   .then((payload) => {
  //   //     // Open the Zoho viewer in a new tab immediately
  //   //     console.log(payload)
  //   //     window.open(payload.viewUrl, "_blank", "noopener,noreferrer");
  //   //   })
  //   //   .catch((err) => {
  //   //     console.error("Failed to get Zoho link:", err);
  //   //   });
  //   window.open(url, "_blank", "noopener,noreferrer");
  // };

  const formatIDNumber = (type, value) => {
    if (!value) return "";

    // Guard: If it's the NBI date, do not apply regex masking
    if (type === GovernmentDocType.NBI) return value;

    // 1. For strictly numeric IDs, strip non-digits
    const nums = value.replace(/\D/g, "");

    // 2. For alphanumeric IDs (Passport/DL), we keep letters but force Uppercase
    const alphaNum = value.toUpperCase();

    switch (type) {
      case GovernmentDocType.SSS:
        return nums
          .replace(/^(\d{2})(\d)/, "$1-$2")
          .replace(/-(\d{7})(\d)/, "-$1-$2")
          .substring(0, 12);

      case GovernmentDocType.PHILHEALTH:
        return nums
          .replace(/^(\d{2})(\d)/, "$1-$2")
          .replace(/-(\d{9})(\d)/, "-$1-$2")
          .substring(0, 14);

      case GovernmentDocType.PAGIBIG:
        return nums
          .replace(/^(\d{4})(\d)/, "$1-$2")
          .replace(/-(\d{4})(\d)/, "-$1-$2")
          .substring(0, 14);

      case GovernmentDocType.TIN:
        return nums
          .replace(/^(\d{3})(\d)/, "$1-$2")
          .replace(/-(\d{3})(\d)/, "-$1-$2")
          .replace(/-(\d{3})(\d{3,5})/, "-$1-$2")
          .substring(0, 15);

      case GovernmentDocType.DRIVERSLICENSE:
        // Pattern: L00-00-000000 (1 Letter + 10 Digits)
        // We strip everything that isn't a letter or digit, then add dashes
        const cleanDL = alphaNum.replace(/[^A-Z0-9]/g, "");
        return cleanDL
          .replace(/^([A-Z]\d{2})(\d)/, "$1-$2")
          .replace(/-(\d{2})(\d)/, "$1-$2")
          .substring(0, 13);

      case GovernmentDocType.PASSPORT:
        // Pattern: P0000000A (Generally 9 characters)
        // Just force Uppercase and remove special characters
        return alphaNum.replace(/[^A-Z0-9]/g, "").substring(0, 9);

      case GovernmentDocType.PRCID:
        // Pattern: 0000000 (7 Digits)
        return nums.substring(0, 7);

      default:
        return value;
    }
  };
  const getValidationError = (type, value) => {
    if (!value) {
      return isSeasonal ? null : "Required";
    }

    const cleanValue = value.replace(/\D/g, "");

    switch (type) {
      case GovernmentDocType.SSS:
        return cleanValue.length !== 10 ? "Must be 10 digits" : null;

      case GovernmentDocType.PHILHEALTH:
      case GovernmentDocType.PAGIBIG:
      case GovernmentDocType.TIN:
        return cleanValue.length !== 12 ? "Must be 12 digits" : null;

      case GovernmentDocType.PASSPORT:
        return value.length < 6 ? "Invalid Passport length" : null;

      case GovernmentDocType.DRIVERSLICENSE:
        return value.length < 11 ? "Invalid License format" : null;

      case GovernmentDocType.PRCID:
        return cleanValue.length < 7 ? "Invalid PRC ID" : null;

      default:
        return null;
    }
  };

const handleSave = async (section, setter) => {
  const label =
    section.docType === GovernmentDocType.OTHER
      ? section.docName || "Other"
      : section.docType;

  if (!section.idNumber?.trim() || !section.file) {
    showStatus(`${label} ID and attachment are required.`, "danger");
    return;
  }

  const companyId = employee?.companyId || employee?.company?.id;
  if (!companyId) {
    showStatus("Error: Employee company context missing.", "danger");
    return;
  }

  setIsProcessing(true);
  try {
    let currentDocId = section.docId;
    const payload = {
      doc_type: section.docType,
      docName: section.docName || section.docType,
      id_number: section.idNumber,
      // If your update endpoint handles saving the manual verification state status directly,
      // we include it here to ensure it persists in the DB row fallback data:
      isValidated: section.isValidated,
    };

    // 1️⃣ STEP 1: Save or Create the text Metadata row first
    if (currentDocId) {
      await dispatch(
        updateDocument({ id: currentDocId, data: payload }),
      ).unwrap();
    } else {
      const createRes = await dispatch(
        createDocument({ employeeId, data: payload }),
      ).unwrap();
      
      currentDocId = createRes.id || createRes.docId || createRes.data?.id;
    }

    if (!currentDocId) {
      throw new Error("No document ID returned from database creation.");
    }

    // 2️⃣ STEP 2: Handle the File Upload (Crucial to run before validation!)
    if (section.file && typeof section.file !== "string") {
      try {
        await dispatch(
          uploadDocumentFile({
            id: currentDocId,
            file: section.file,
            companyId: companyId,
          }),
        ).unwrap();
      } catch (uploadErr) {
        console.error("File upload failed:", uploadErr);
        const errorMessage =
          uploadErr?.error ||
          uploadErr ||
          "Storage provider upload rejected.";
        showStatus(`${errorMessage}`, "danger");
        return; // Halt execution immediately so validation/success triggers do not run
      }
    }

    // 3️⃣ STEP 3: Conditional Validation Based on UI Toggle Switch
    // 🚀 Only trigger backend verification if the toggle switch is turned on (true)
    if (section.isValidated) {
      console.log(`[FRONTEND] Switch is checked. Dispatching validation loop for ID: ${currentDocId}`);
      await dispatch(
        validateDoc({
          docId: currentDocId,
          companyId: companyId,
        }),
      ).unwrap();
    } else {
      console.log(`[FRONTEND] Switch is unchecked. Skipping automated validation pipeline.`);
    }

    // 4️⃣ STEP 4: Complete Lifecycle Actions if everything succeeded
    await dispatch(checkEmployeeCompleteness(employeeId)).unwrap();
    showStatus(`${label} saved successfully!`);

    if (section.docType === GovernmentDocType.OTHER && !section.docId) {
      setIsAddingOther(false);
      setNewOther(initialSectionState(GovernmentDocType.OTHER));
    }

    // Refresh the application storage state array elements
    dispatch(getDocumentsByEmployee(employeeId));
    dispatch(fetchEmployeeById(employeeId));
  } catch (err) {
    console.error("Document operation failed:", err);
    showStatus(err?.message || "Error saving document execution profile", "danger");
  } finally {
    setIsProcessing(false);
  }
};

  const handleDelete = async (docId) => {
    if (!window.confirm("Delete record?")) return;
    setIsProcessing(true);
    try {
      await dispatch(deleteDocument(docId)).unwrap();
      await dispatch(checkEmployeeCompleteness(employeeId)).unwrap();
      showStatus("Document deleted!");
      dispatch(getDocumentsByEmployee(employeeId));
    } catch (err) {
      showStatus(err?.message || "Error deleting", "danger");
    } finally {
      setIsProcessing(false);
    }
  };

  const handleCancel = (section, setter) => {
    if (section.docType === GovernmentDocType.OTHER && !section.docId) {
      setIsAddingOther(false);
      setNewOther(initialSectionState(GovernmentDocType.OTHER));
      return;
    }
    const existing = documents.find((d) =>
      section.docId
        ? d.id === section.docId || d.docId === section.docId
        : d.docType === section.docType,
    );

    if (existing) {
      const originalState = {
        docType: existing.docType,
        docName: existing.docName || null,
        idNumber: existing.idNumber || "",
        file: existing.file || existing.file_url || null,
        docId: existing.docId || existing.id,
        editing: false,
      };

      setter((prev) =>
        Array.isArray(prev)
          ? prev.map((p) =>
              p.docId === section.docId || p.id === section.docId
                ? originalState
                : p,
            )
          : originalState,
      );
    } else {
      setter((prev) =>
        Array.isArray(prev)
          ? prev.filter((p) => p.docId !== section.docId)
          : initialSectionState(section.docType),
      );
    }
  };

  const renderRow = (section, setter, isMandatoryRow = true) => {
    const isSaved = !!section.docId;
    const isNbi = section.docType === GovernmentDocType.NBI;
    const isOther = section.docType === GovernmentDocType.OTHER;

    const vError = getValidationError(section.docType, section.idNumber);
    const isValid = vError === null;
    const isRequired = isMandatoryRow && !isSeasonal;

    return (
      <tr
        key={section.docId || section.docType + section.docName}
        className={section.editing ? "bg-primary bg-opacity-10" : ""}
      >
        <td className="ps-4 fw-bold text-dark" style={{ fontSize: "0.85rem" }}>
          {isRequired && <span className="text-danger me-1">*</span>}
          {isOther ? section.docName : section.docType}
        </td>
        <td>
          <input
            // IMPROVED LOGIC: If editing is ON and it's NBI, force "date" type
            // so the dropdown/calendar appears. Otherwise, if it's "N/A", keep it as "text".
            type={
              isNbi && (section.editing || section.idNumber !== "N/A")
                ? "date"
                : "text"
            }
            readOnly={!section.editing}
            value={
              isNbi
                ? (() => {
                    // While editing, if the value is "N/A", we return an empty string
                    // so the date input shows "mm/dd/yyyy" placeholder instead of crashing.
                    if (section.idNumber === "N/A")
                      return section.editing ? "" : "N/A";

                    return DateUtils.formatToInput(section.idNumber);
                  })()
                : section.idNumber || ""
            }
            onChange={(e) => {
              let val = e.target.value;

              // Standard HTML date input returns YYYY-MM-DD
              if (isNbi && val && val.includes("-")) {
                const [y, m, d] = val.split("-");
                // Convert back to your DB format MM/DD/YYYY
                val = `${parseInt(m)}/${parseInt(d)}/${y}`;
              }

              if (!isNbi) {
                val = formatIDNumber(section.docType, val);
              }

              setter((prev) =>
                Array.isArray(prev)
                  ? prev.map((p) =>
                      p.docId === section.docId ? { ...p, idNumber: val } : p,
                    )
                  : { ...prev, idNumber: val },
              );
            }}
            title={
              isNbi && section.idNumber === "N/A"
                ? "NBI Clearance requires a valid Expiration Date"
                : ""
            }
            className={`form-control form-control-sm fw-bold ${
              section.editing
                ? "bg-white border shadow-sm"
                : "border-0 bg-transparent"
            } ${isNbi && section.idNumber === "N/A" && !section.editing ? "text-danger" : ""}`}
            style={{ fontSize: "0.85rem", height: "32px", borderRadius: "8px" }}
          />
        </td>
        <td className="text-center">
          <div className="position-relative d-inline-block">
            {section.editing && (
              <input
                type="file"
                accept=".pdf, .jpg, .jpeg, .png"
                className="position-absolute opacity-0 w-100 h-100 cursor-pointer"
                style={{ zIndex: 2 }}
                onChange={(e) => {
                  const file = e.target.files[0];
                  if (!file) return;
                  setter((prev) =>
                    Array.isArray(prev)
                      ? prev.map((p) =>
                          p.docId === section.docId ? { ...p, file: file, isValidated: false } : p,
                        )
                      : { ...prev, file: file, isValidated: false },
                  );
                  e.target.value = "";
                }}
              />
            )}
            <div
              className={`d-flex align-items-center justify-content-center px-3 py-1 fw-bold text-white shadow-sm transition-all`}
              style={{
                fontSize: "0.6rem",
                backgroundColor: section.file ? "#198754" : "#475569",
                borderRadius: "6px",
                minWidth: "90px",
                height: "26px",
              }}
            >
              <i
                className={`bi ${section.file ? "bi-check-circle-fill" : "bi-cloud-arrow-up-fill"} me-2`}
              ></i>
              {section.file ? "UPLOADED" : "ATTACH"}
            </div>
          </div>
        </td>

<td className="text-center" style={{ width: "80px" }}>
  <div className="form-check form-switch d-inline-block m-0">
    {(() => {
      const govDocTypes = [
        "SSS",
        "PhilHealth",
        "Pag-IBIG",
        "TIN",
        "NBI Clearance",
        "Passport",
      ];

      if (!govDocTypes.includes(section.docType)) {
        return <span>{section.docType}</span>;
      }

      // 🚀 Ensure validation status strictly defaults to false if undefined/missing
      const isCurrentlyValidated = !!section.isValidated; 

      const isDataComplete = !!section.idNumber && !!section.file;
      const isLocked = isCurrentlyValidated; // Locked if already validated by backend
      const canToggle = section.editing && isDataComplete && !isLocked;

      return (
        <input
          className="form-check-input cursor-pointer shadow-none"
          type="checkbox"
          role="switch"
          style={{ width: "2.4rem", height: "1.2rem" }}
          // Read-only/Disabled constraints
          readOnly={isCurrentlyValidated}
          disabled={!canToggle}
          // 🚀 Explicitly checked status evaluated against the strict boolean
          checked={isCurrentlyValidated}
          title={
            !isDataComplete
              ? "Please provide ID Number and File to validate"
              : ""
          }
          onChange={(e) => {
            const isChecked = e.target.checked;

            // Update state array or object dynamically
            setter((prev) =>
              Array.isArray(prev)
                ? prev.map((p) =>
                    p.docId === section.docId
                      ? { ...p, isValidated: isChecked }
                      : p,
                  )
                : { ...prev, isValidated: isChecked },
            );
          }}
        />
      );
    })()}
  </div>
</td>

        <td className="pe-4 text-end">
          <div className="d-flex justify-content-end gap-2">
            {section.editing ? (
              <>
                <button
                  className="btn btn-sm btn-success py-0 px-2 shadow-sm"
                  style={{ height: "28px" }}
                  onClick={() => handleSave(section, setter)}
                  disabled={isProcessing || !section.file}
                >
                  <i className="bi bi-check-lg text-white"></i>
                </button>
                <button
                  className="btn btn-sm btn-outline-secondary py-0 px-2 shadow-sm bg-white"
                  style={{ height: "28px" }}
                  onClick={() => handleCancel(section, setter)}
                >
                  <i className="bi bi-x-lg"></i>
                </button>
              </>
            ) : (
              <>
                <button
                  className="btn btn-sm border-0 shadow-none"
                  onClick={() =>
                    setter((prev) =>
                      Array.isArray(prev)
                        ? prev.map((p) =>
                            p.docId === section.docId
                              ? { ...p, editing: true }
                              : p,
                          )
                        : { ...prev, editing: true },
                    )
                  }
                >
                  <i className="bi bi-pencil-square text-primary"></i>
                </button>
                {section.file && typeof section.file === "string" && (
                  <button
                    type="button"
                    onClick={() => handleViewFile(section.file)}
                    className="btn btn-sm border-0 shadow-none"
                    title="View Document"
                  >
                    <i className="bi bi-eye-fill text-primary"></i>
                  </button>
                )}
                {isSaved && (
                  <button
                    className="btn btn-sm border-0 shadow-none"
                    onClick={() => handleDelete(section.docId)}
                  >
                    <i className="bi bi-trash3-fill text-danger"></i>
                  </button>
                )}
              </>
            )}
          </div>
        </td>
      </tr>
    );
  };

let completedCount = 0;
let progressPercentage = 0;
const documentsArray = employee?.documents || [];

if (employee?.company?.companyName !== "Wizard International Manpower Services, Inc.") {
  // Track 1: 5 Core Statutory Documents
  completedCount = [sss, philHealth, pagIbig, TIN, NBI].filter(
    (doc) => 
doc 
    && 
    doc.docId 
    && 
    doc.file && 
    doc.isValidated === true
  ).length;

  progressPercentage = Math.round((completedCount / 5) * 100);
} else {
  completedCount = [
    sss, philHealth, pagIbig, TIN, NBI, passport, peos, eRegistration,
    insurancePolicy, birthCertificate, oec, pdos, medical, driversLicense,
    marriageCertificate, healthCard, occupationalPermit, prcId, coe,
    apostilledDocs, certification, diploma, tor
  ].filter(
    (doc) => 
doc && 
    doc.docId?.trim() && 
    doc.file_url?.trim() && 
    doc.isValidated === true// 3. Explicitly validated
  ).length;
  
  progressPercentage = Math.round((completedCount / 23) * 100);
}

  return (
    <div className="container-fluid py-2 px-0">
      <style>{`.progress-overlay { position: absolute; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255,255,255,0.7); z-index: 1000; display: flex; align-items: center; justify-content: center; border-radius: 8px; }`}</style>
      <div className="bg-white p-3 rounded-3 shadow-sm border mb-4 position-relative">
        {isProcessing && (
          <div className="progress-overlay">
            <div className="spinner-border text-primary"></div>
          </div>
        )}

        <div
          className="d-flex justify-content-between align-items-center px-3 py-2 rounded-2 mb-2"
          style={{ backgroundColor: "#1e293b" }}
        >
          <div className="d-flex align-items-center">
            <h6
              className="fw-bold m-0 text-white text-uppercase"
              style={{ fontSize: "0.75rem" }}
            >
              {isSeasonal ? "Documents (Seasonal)" : "Mandatory Documents"}
            </h6>
          </div>
          {employee?.company?.companyName ===
          "Wizard International Manpower Services, Inc." ? (
            <div
              className="px-3 py-1 rounded-pill text-white fw-bold shadow-sm"
              style={{
                backgroundColor: completedCount === 23 ? "#198754" : "#334155",
                fontSize: "0.6rem",
              }}
            >
              {completedCount} / 23 COMPLETED
            </div>
          ) : (
            <div
              className="px-3 py-1 rounded-pill text-white fw-bold shadow-sm"
              style={{
                backgroundColor: completedCount === 5 ? "#198754" : "#334155",
                fontSize: "0.6rem",
              }}
            >
              {completedCount} / 5 COMPLETED
            </div>
          )}
        </div>
        {statusMsg?.text && (
          <div
            className={`alert alert-${statusMsg.type} extra-small py-1 mb-2`}
            role="alert"
          >
            {statusMsg.text}
          </div>
        )}

        <div className="px-1 mb-4">
          <div className="progress shadow-sm" style={{ height: "6px" }}>
            <div
              className={`progress-bar ${completedCount === 5 ? "bg-success" : "bg-primary"}`}
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
        </div>

        <div className="table-responsive rounded-2 border mb-5 shadow-sm">
          <table className="table table-hover align-middle mb-0">
            <thead style={{ backgroundColor: "#f8fafc" }}>
              <tr style={{ fontSize: "0.65rem", color: "#64748b" }}>
                <th className="py-2 ps-4 fw-bold">DOCUMENT TYPE</th>
                <th className="py-2 fw-bold">ID NUMBER / DATE</th>
                <th className="py-2 text-center fw-bold">FILE ATTACHMENT</th>
                <th className="py-2 text-center fw-bold">VALIDATED</th>
                <th className="py-2 pe-4 text-end fw-bold">ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {employee?.company?.companyName ===
              "Wizard International Manpower Services, Inc." ? (
                <>
                  {renderRow(pagIbig, setPagIbig)}
                  {renderRow(NBI, setNBI)}
                  {renderRow(passport, setPassport)}
                  {renderRow(peos, setPeos)}
                  {renderRow(eRegistration, setERegistration)}
                  {renderRow(insurancePolicy, setInsurancePolicy)}
                  {renderRow(oec, setOec)}
                  {renderRow(pdos, setPdos)}
                  {renderRow(medical, setMedical)}
                  {renderRow(driversLicense, setDriversLicense,false)}
                  {renderRow(birthCertificate, setBirthCertificate)}
                  {renderRow(marriageCertificate, setMarriageCertificate,false)}
                  {renderRow(healthCard, setHealthCard,false)}
                  {renderRow(occupationalPermit, setOccupationalPermit,false)}
                  {renderRow(prcId, setPrcId,false)}
                  {renderRow(coe, setCoe,false)}
                  {renderRow(apostilledDocs, setApostilledDocs,false)}
                  {renderRow(certification, setCertification,false)}
                  {renderRow(diploma, setDiploma,false)}
                  {renderRow(tor, setTor,false)}
                </>
              ) : (
                <>
                  {renderRow(sss, setSss)}
                  {renderRow(philHealth, setPhilHealth)}
                  {renderRow(pagIbig, setPagIbig)}
                  {renderRow(TIN, setTIN)}
                  {renderRow(NBI, setNBI)}
                </>
              )}
            </tbody>
          </table>
        </div>

        <div
          className="d-flex justify-content-between align-items-center px-3 py-2 rounded-2 mb-3 shadow-sm"
          style={{ backgroundColor: "#1e293b" }}
        >
          <h6
            className="fw-bold m-0 text-white text-uppercase"
            style={{ fontSize: "0.7rem" }}
          >
            Other Documents
          </h6>
          <button
            className="btn btn-sm btn-success px-3 shadow-none border-0"
            onClick={() => setIsAddingOther(true)}
          >
            <i className="bi bi-plus-circle me-2"></i> Add
          </button>
        </div>

        <div className="table-responsive rounded-2 border shadow-sm">
          <table className="table table-hover align-middle mb-0">
            <tbody>
              {otherDocs.map((doc) => renderRow(doc, setOtherDocs, false))}
              {isAddingOther && (
                <tr className="bg-primary bg-opacity-10">
                  <td className="ps-4">
                    <input
                      type="text"
                      className="form-control form-control-sm bg-white border shadow-sm fw-bold"
                      placeholder="Doc Name..."
                      value={newOther.docName}
                      onChange={(e) =>
                        setNewOther((p) => ({
                          ...p,
                          docName: e.target.value,
                          editing: true,
                        }))
                      }
                      style={{ height: "32px", borderRadius: "8px" }}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control form-control-sm bg-white border shadow-sm fw-bold"
                      placeholder="ID..."
                      value={newOther.idNumber}
                      onChange={(e) =>
                        setNewOther((p) => ({ ...p, idNumber: e.target.value }))
                      }
                      style={{ height: "32px", borderRadius: "8px" }}
                    />
                  </td>
                  <td className="text-center">
                    <div className="position-relative d-inline-block">
                      <input
                        type="file"
                        className="position-absolute opacity-0 w-100 h-100 cursor-pointer"
                        style={{ zIndex: 2 }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) setNewOther((p) => ({ ...p, file: file }));
                        }}
                      />
                      <div
                        className="d-flex align-items-center justify-content-center px-3 py-1 fw-bold text-white shadow-sm"
                        style={{
                          fontSize: "0.6rem",
                          backgroundColor: newOther.file
                            ? "#198754"
                            : "#475569",
                          borderRadius: "6px",
                          minWidth: "90px",
                          height: "26px",
                        }}
                      >
                        <i
                          className={`bi ${newOther.file ? "bi-check-circle-fill" : "bi-cloud-arrow-up-fill"} me-2`}
                        ></i>
                        {newOther.file ? "UPLOADED" : "ATTACH"}
                      </div>
                    </div>
                  </td>
                  <td className="pe-4 text-end">
                    <div className="d-flex gap-2 justify-content-end">
                      <button
                        className="btn btn-success btn-sm"
                        onClick={() => handleSave(newOther, setNewOther)}
                        disabled={
                          !newOther.docName || !newOther.file || isProcessing
                        }
                      >
                        <i className="bi bi-check-lg"></i>
                      </button>
                      <button
                        className="btn btn-sm"
                        onClick={() => setIsAddingOther(false)}
                      >
                        <i className="bi bi-trash3-fill text-danger"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EmployeeGovernmentDoc;
